import {makeObservable} from 'mobx';

import type {Nullable} from '../../../../utils/utility-types';
import type {DateTimeModel} from '../../Date/DateTime.model';
import type {UserModel} from '../../User/User.model';
import type {UserAdditionalDataModel} from '../UserAdditionalData/UserAdditionalData.model';

import {BaseModel} from '../../Base/Base.model';

const ModelName = 'PrivateProfileModel';

export class PrivateProfileModel extends BaseModel {
  additionalData: Nullable<UserAdditionalDataModel> = null;
  dateOfBirth: Nullable<DateTimeModel> = null;
  email: Nullable<string> = null;
  firstName: Nullable<string> = null;
  gender: Nullable<UserModel.Gender> = null;
  isEmpty = false;
  lastName: Nullable<string> = null;
  location: Nullable<string> = null;
  middleName: Nullable<string> = null;
  partnerId: Nullable<string> = null;
  phone: Nullable<string> = null;
  reasonsForCoaching: Nullable<Record<string, any>[]> = null;
  timezone: Nullable<string> = null;

  constructor(props: PrivateProfileModel.Props) {
    super({id: ''});
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<
        PrivateProfileModel,
        PrivateProfileModel.Props
      >(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace PrivateProfileModel {
  export type Props = BaseModel.ModelToProps<PrivateProfileModel, 'id'>;
}
